import { AdAuditFilter, ListResult } from 'common/api/v1/types'
import { EdgeClient } from 'common/generated/edgeClient'
import { AdAuditLogRequestParams, singleSortQueryFromPaginatedRequestParams } from '../nm-types'
import { AdAuditLogMessage } from 'common/types'
import { parseFilterValues } from '../filterValues'

export class AdAuditApi {
  constructor(private readonly edgeClient: EdgeClient) {}

  getAdAudit(params: AdAuditLogRequestParams): Promise<ListResult<AdAuditLogMessage>> {
    /**
     * Converts a comma-separated string to an array of strings
     */
    const toStringArray = (value?: string): string[] | undefined => {
      if (!value) return undefined
      const arr = parseFilterValues(value)
        .map((v) => v.trim())
        .filter((v) => v.length > 0)
      return arr.length > 0 ? arr : undefined
    }

    /**
     * Converts a comma-separated string of numbers to an array of numbers
     */
    const toNumberArray = (value?: string): number[] | undefined => {
      if (!value) return undefined
      const arr = parseFilterValues(value)
        .map((v) => parseInt(v.trim(), 10))
        .filter((v) => !isNaN(v))
      return arr.length > 0 ? arr : undefined
    }

    const inputNames = params.inputs ? (toStringArray(params.inputs) ?? []) : []

    const filter: AdAuditFilter = {
      filter: params.filter,
      fromDate: params.fromDate ? new Date(params.fromDate) : undefined,
      toDate: params.toDate ? new Date(params.toDate) : undefined,
      // Convert comma-separated strings to arrays for multi-value fields
      entityTypes: toStringArray(params.entityType),
      methods: toStringArray(params.method),
      results: toStringArray(params.result),
      statuses: toStringArray(params.status),
      channelIds: toNumberArray(params.channelId),
      components: toStringArray(params.component),
      message: params.message,
      eventId: params.eventId ? Number(params.eventId) : undefined,
      inputIds: (() => {
        const ids: string[] = []
        if (params.inputId) ids.push(params.inputId)
        if (params.inputIds) ids.push(...params.inputIds)
        return ids.length > 0 ? ids : undefined
      })(),
      inputNames: inputNames.length > 0 ? inputNames : undefined,
      streamId: params.streamId ? Number(params.streamId) : undefined,
      pod: params.pod,
      entity: params.entity,
      entityId: params.entityId,
      entityName: params.entityName,
      entitySize: params.entitySize ? Number(params.entitySize) : undefined,
      source: params.source,
      target: params.target,
      traceId: params.traceId,
      adBreakIds: toStringArray(params.adBreakId),
      programNumber: params.programNumber ? Number(params.programNumber) : undefined,
      programName: params.programName,
    }
    const query = singleSortQueryFromPaginatedRequestParams({ filter, paginatedRequestParams: params })
    return this.edgeClient.listAdAuditLogs(query)
  }
}
